module.exports = __webpack_public_path__ + "static/media/m1.56fb0e54.png";